import { useState, useRef, useEffect } from "react";
import styles from "./Expandable.module.css";

type ExpandableProps = {
  isOpen: boolean;
  children: React.ReactNode;
  duration?: number;
};

export const Expandable = ({ isOpen, children, duration = 200 }: ExpandableProps) => {
  const [height, setHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const node = contentRef.current;
    if (!node) {
      return;
    }

    const updateHeight = () => {
      setHeight(isOpen ? node.scrollHeight : 0);
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(node);

    return () => resizeObserver.disconnect();
  }, [isOpen]);

  return (
    <div className={styles.root} style={{ height: `${height}px`, transition: `height ${duration}ms ease` }}>
      <div className={styles.content} ref={contentRef}>
        {children}
      </div>
    </div>
  );
};
